export default "__VITE_ASSET__BYDP8sMn__"